
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/providers",
      function () {
        return require("private-next-pages/sitemap/providers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/providers"])
      });
    }
  